<template>
  <div class="content">
    <div class="content-item" >
        <div class="box-head">
          <div class="box-title">
            <img src="/static/img/jt.png" >
            <div>设备联网率</div>
          </div>
          <div class="box-line-1"></div>
          <div class="box-line-2"></div>
          <div class="box-line-3"></div>
          <div class="box-line-4"></div>
        </div>
        <div class="box-body">
          <div class="com-chart" ref="stock_ref"></div>
        </div>
    </div>
    <div class="content-item" >
        <div style="height: 50%;display: flex;flex-direction: column;">
          <div class="box-head">
            <div class="box-title">
              <img src="/static/img/jt.png" >
              <div>盐货云选</div>
            </div>
            <div class="box-line-1"></div>
            <div class="box-line-2"></div>
            <div class="box-line-3"></div>
            <div class="box-line-4"></div>
          </div>
          <div class="box-body" style="flex: 1;">
            <div class="bg"><div>{{value.num1}}</div></div>
          </div>
        </div>
        <div style="height: 50%;display: flex;flex-direction: column;">
          <div class="box-head">
            <div class="box-title">
              <img src="/static/img/jt.png" >
              <div>智创集采</div>
            </div>
            <div class="box-line-1"></div>
            <div class="box-line-2"></div>
            <div class="box-line-3"></div>
            <div class="box-line-4"></div>
          </div>
          <div class="box-body" style="flex: 1;">
            <div class="bg1"><div>{{value.num2}}</div></div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        chartInstance: null,
        allData: null,

        value : {
          num1 : '',
          num2 : ''
        },
      }
    },
    mounted() {
    	this.initChart();
    	this.getData();
    	window.addEventListener("resize", this.screenAdapter);
    	this.screenAdapter();
    },
    destroyed() {
    	window.removeEventListener("resize", this.screenAdapter);
    	clearInterval(this.timerId);
    },
    methods: {
      initChart() {
        this.chartInstance = this.$echarts.init(
          this.$refs.stock_ref,
          "chalk"
        );
        const initOption = {};
        this.chartInstance.setOption(initOption);
        this.chartInstance.on("mouseover", () => {
          clearInterval(this.timerId);
        });
        this.chartInstance.on("mouseout", () => {
          this.startInterval();
        });
      },
      async getData() {
      	const { data: ret } = await axios.get(
      		"/left-bottom-two"
      	);
      	this.allData = ret.data;
        this.value = ret.value
      	this.updateChart();
      	this.startInterval();
      },
      updateChart() {
      	// 处理图表需要的数据
      	const titleFontSize =
      		(this.$refs.stock_ref.offsetWidth / 100) * 3.6;
      	const innerRadius = titleFontSize * 5;
      	const outterRadius = innerRadius * 1.425;

      	const showData = this.allData;

      	const seriesArr = showData.map((item, index) => {
      		return {
      			type: "pie",
      			// radius: [100, 70],
      			center: ["50%", "50%"],
      			hoverAnimation: false, // 关闭鼠标移入到饼图时的动画效果
      			labelLine: {
      				show: false, // 隐藏指示线
      			},
      			radius: [outterRadius, innerRadius],
      			label: {
      				position: "center",
      				color: ["#1FF2C2", "#25DFF3"],
      				fontSize: titleFontSize * 3,
      			},
      			data: [
      				{
      					name: item.used + "%",
      					value: item.used,
      					itemStyle: {
      						color: new this.$echarts.graphic.LinearGradient(
      							0,
      							1,
      							0,
      							0,
      							[
      								{
      									offset: 0,
      									color: "#1FF2C2",
      								},
      								{
      									offset: 1,
      									color: "#25DFF3",
      								},
      							]
      						),
      					},
      				},
      				{
      					value: item.noused,
      					itemStyle: {
      						color: "#12869A",
      					},
      				},
      			],
      		};
      	});
      	const dataOption = {
      		series: seriesArr,
      	};
      	this.chartInstance.setOption(dataOption);
      },
      screenAdapter() {
      	const titleFontSize =
      		(this.$refs.stock_ref.offsetWidth / 100) * 3.6;
      	const innerRadius = titleFontSize * 2;
      	const outterRadius = innerRadius * 1.125;
      	const adapterOption = {
      		title: {
      			textStyle: {
      				fontSize: titleFontSize,
      			},
      		},
      	};
      	this.chartInstance.setOption(adapterOption);
      	this.chartInstance.resize();
      },
      startInterval() {
      	if (this.timerId) {
      		clearInterval(this.timerId);
      	}
      	this.timerId = setInterval(() => {
      		this.currentIndex++;
      		if (this.currentIndex > 1) {
      			this.currentIndex = 0;
      		}
      		this.updateChart(); // 在更改完currentIndex之后 , 需要更新界面
      	}, 5000);
      },
    },
  }
</script>

<style lang="less" scoped>
  .bg{
    background: url("/static/img/p4.2@3x.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
	    width: 87%;
	    height: 3.3125rem;
	position: relative;
    div{
      position: absolute;
      left: 0.5375rem;
      color: #00C4F7;
      font-weight: bold;
     font-size:1.125rem;
    }
  }
  .bg1{
    background: url("/static/img/p4.3@3x.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    width: 87%;
    height: 3.3125rem;
    position: relative;
    div{
      position: absolute;
      left: 0.5375rem;
      color: #00C4F7;
      font-weight: bold;
       font-size:1.125rem;
    }
  }


  .content{
    display: flex; justify-content: space-between;height: 100%;
    .content-item{
      width: 48%; display: flex;flex-direction: column;
      .box-head{
        position: relative;
        .box-title{
          display: flex; align-items: center; padding: 10px 7px; border-bottom: 1px solid #0087F9;
          div{
            color: #00EDFF;margin-left: 0.625rem;font-size: 1.25rem;
          }
          span{
            color: #0087F9;font-size: 0.875rem;align-self: end;margin-left: 0.625rem;
          }
        }
      }
      .box-body{
        flex: 1;background-color: rgba(7,65,122,0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
          background: url("/static/img/tk.png");
          background-repeat: no-repeat;
          background-size: cover;
          -webkit-background-size: cover;
          -o-background-size: cover;
          background-position: center 0;
          padding: 0.3125rem 1.25rem;
          font-weight:bold;
           margin-top: 1.25rem;
        }
        .time{
          background: url("/static/img/rjsysc@3x.png");
          background-repeat: no-repeat;
          background-size: cover;
          -webkit-background-size: cover;
          -o-background-size: cover;
          background-position: center 0;
          margin-top: 1.25rem;
          height: 120px;
          width: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .time-1{
            font-weight: bold;
            color: #00EDFF;
          }
          .time-2{
            font-size: 0.75rem;
            color: #00EDFF;
          }
        }
        .act{
          background: url("/static/img/hyd@3x.png");
          background-repeat: no-repeat;
          background-size: cover;
          -webkit-background-size: cover;
          -o-background-size: cover;
          background-position: center 0;
          margin-top: 1.25rem;
          height: 120px;
          width: 120px;
        }
      }
    }
  }


  .box-line-1{
       position: absolute;
       top: 0;
       left: 0;
       width: 10px;
       height: 10px;
       border-top: 1px solid #44C4FF;
  }
  .box-line-2{
   position: absolute;
   top: 0;
   right: 0;
   width: 10px;
   height: 10px;
   border-top: 1px solid #44C4FF;
  }
  .box-line-3{
   position: absolute;
   bottom: 0;
   left: 0;
   width: 10px;
   height: 10px;
   border-bottom: 1px solid #44C4FF;
  }
  .box-line-4{
   position: absolute;
   bottom: 0;
   right: 0;
   width: 10px;
   height: 10px;
   border-bottom: 1px solid #44C4FF;
  }


</style>
